const initialState = [];
export const notificationsHistory = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATIONS_HISTORY_DATA':
      return action.payload;
    default:
      return state;
  }
};
